import * as React from 'react';
import ImageField from 'src/core/ui/data-component/data-image';
import Fade from 'react-reveal/Fade';

export interface ProcessDetailImageProps {
    id: string;
    title?: string;
    className?: string;
}

export interface ProcessDetailImageState {
}

export default class ProcessDetailImage extends React.Component<ProcessDetailImageProps, ProcessDetailImageState> {
  constructor(props: ProcessDetailImageProps) {
    super(props);
  }

  public render() {
      const { className, id, title } = this.props;
      return (
          <div className={`process-description ${className}`}>
            <Fade left={true}>
              <ImageField className="process-image" id={id} />
            </Fade>
              {/*<Fade right={true}>*/}
              <h2 className="process-name">{title}</h2>
              {/*</Fade>*/}
          </div>
        );
      }
}



// WEBPACK FOOTER //
// ./src/components/arts/process-detail.tsx